import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { take } from 'rxjs/operators';
import { DataDefinitionComponent } from '../../../../admin360/data-definition/data-definition.component';
import { CustomizationFrameworkService } from '../../../../shared-modules/customization-framework/customization-framework.service';

@Component({
  selector: 'data-def-button',
  templateUrl: './data-def-button.component.html',
  styleUrls: ['./data-def-button.component.css']
})
export class DataDefButtonComponent implements OnInit {

  @Input() dataDefEnum: string;
  @Input() disabled: boolean;
  @Output() dataDefUpdated = new EventEmitter<boolean>();
  
  constructor(
    private customizationFrameworkService: CustomizationFrameworkService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
  }

  editClick() {
    if (!this.disabled) {
      const dataDef = this.customizationFrameworkService.dataDefinitionLists.find(o => o.Enum == this.dataDefEnum);
      if (dataDef) {
        const addEdditDialog = this.dialog.open(DataDefinitionComponent, {
          data: dataDef,
          disableClose: true
        });
        addEdditDialog.afterClosed().pipe(take(1)).subscribe(() => {
          this.dataDefUpdated.emit(true);
        });
      }
    }
  }

}
